// import { Component, Input } from '@angular/core';
// @Component({
//   selector: 'app-radial-gauge',
//   templateUrl: './radial-gauge.component.html',
//   styleUrls: ['./radial-gauge.component.scss']
// })
// export class RadialGaugeComponent {
//   @Input() inputData: any;
// }

import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { GaugeChartComponent } from '../device-detail-nxt/gauge-chart-component/gauge-chart-component.component';

@Component({
  selector: 'app-radial-gauge',
  templateUrl: './radial-gauge.component.html',
  styleUrls: ['./radial-gauge.component.scss'],
  standalone: true,
  imports: [CommonModule,GaugeChartComponent]
})
export class RadialGaugeComponent implements OnInit {
  @Input() inputData: any;
  loading: boolean = true;

  ngOnInit() {
    // Simulating data loading time
    setTimeout(() => {
      this.loading = false;
    }, 3000); // Adjust the time as needed
  }
}
